import OrderListSearchType from '../enums/OrderListSearchType'
import moment from 'moment'
import ShipmentType from '../enums/ShipmentType'
import PaidType from '../enums/PaidType'

function generateOrderListTypeParam (option, data) {
  if (option === OrderListSearchType.ORDER_NO) {
    return {
      orderId: data
    }
  } else if (option === OrderListSearchType.BUYER_ID) {
    return {
      memberId: data
    }
  } else if (option === OrderListSearchType.BUYER_CELL_PHONE) {
    return {
      cellPhone: data
    }
  } else {
    console.error('OPTION ERROR!!')
  }
}

// 상품 데이터 예시
// {
//   orderId: '20193282-3392',
//   items: [
//     {
//       productName: '피부 영양 덴탈츄 뉴트리션',
//       productPrice: 18000,
//       imageUrl: 'https://picsum.photos/100',
//       shippingCompanyName: 'CJ대한통운',
//       trackingNo: '392942830202'
//     },
//     {
//       productName: '피부 영양 덴탈츄 뉴트리션2',
//       productPrice: 33200,
//       imageUrl: 'https://picsum.photos/100',
//       shippingCompanyName: 'CJ대한통운',
//       trackingNo: '392942830202'
//     }
//   ],
//   orderPriceAmount: 65500,
//   shippingStatus: '배송중',
//   specificOrderUrl: 'https://www.naver.com'
// }

function gatherAllItems (orderArr) {
  let items = []
  let itemInfo = []
  let productIds = []
  orderArr.forEach((order, index) => {
    items = items.concat(order.items)
    order.items.forEach((item) => {
      productIds.push(item.productNo)
    })
    itemInfo.push({
      index: index,
      length: order.items.length
    })
  })
  return {
    data: items,
    productIds: productIds,
    info: itemInfo,
    resultProductIds: productIds.join(',')
  }
}

function getImageLinkArr (productArr) {
  let result = []
  productArr.forEach((product) => {
    result.push({
      productUrl: product.listImage,
      productNo: product.productNo
    })
  })
  return result
}

function convertDate (dateData) {
  if (!dateData) {
    return '-'
  }
  // HH-mm-dd 가 필요해지면 넣는다.
  return moment(dateData).format('YYYY-MM-DD')
}

function findImageLink (productNo, imageArr) {
  let result = ''
  imageArr.forEach((image) => {
    if (image.productNo === productNo) {
      console.log(image, productNo)
      result = image.productUrl
    }
  })
  return result
}

function attachImageLink (orderArr, imageArr) {
  orderArr.forEach((order) => {
    order.items.forEach((item) => {
      let productNo = item.productNo
      let imageLink = findImageLink(productNo, imageArr)
      console.log(imageLink)
      item.imageUrl = imageLink
    })
  })
  return orderArr
}

function convertCurrency (currency, amount) {
  let money = amount.split('.')
  return `${money}${currency}`
}

function linkReceiverAddress (addressArr) {
  let result = ''
  if (!addressArr) {
    return '-'
  }
  addressArr.forEach((address, index) => {
    result += address
    if (index !== addressArr.length - 1) {
      result += '\n'
    }
  })
  return result
}

function linkReturnAddress (addressArr) {
  let result = ''
  if (!addressArr) {
    return '-'
  }
  addressArr.forEach((address, index) => {
    result += address.address1
    result += address.address2
    if (index !== addressArr.length - 1) {
      result += '\n'
    }
  })
  return result
}

// 한화만 쓴다고 가정하지만, 아닐 경우엔 통화 매핑이 필요함.
function handlePrice (price) {
  if (!price) {
    return '0원'
  }
  price = price.replace('원', '')
  price = price.replace(',00', '')
  price = price.replace('.00', '')
  return numberWithCommas(`${price}원`)
}

function numberWithCommas (number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

function handleNumber (number) {
  if (!number) {
    return '-'
  }
  return number
}

function handleDefaultInfo (data) {
  if (!data) {
    return '-'
  }
  return data
}

function getShipmentChipColor (data) {
  if (data === ShipmentType.BEFORE_SHIP) {
    return 'blue'
  } else if (data === ShipmentType.SHIP_ING) {
    return 'green'
  } else {
    return 'grey'
  }
}

function getPaidChipColor (data) {
  if (data === PaidType.NOT_PAID) {
    return 'red'
  } else if (data === PaidType.PAID) {
    return 'green'
  } else {
    return 'orange'
  }
}

function getInitDate () {
  let now = new Date()
  let startDate = moment(now).add(-1, 'months').format('YYYY-MM-DD')
  let endDate = moment(now).format('YYYY-MM-DD')
  return {
    startDate: startDate,
    endDate: endDate
  }
}

function getDateDiffer (start, end) {
  let diffTime = moment(end, 'YYYY-MM-DD').diff(moment(start, 'YYYY-MM-DD'))
  let duration = moment.duration(diffTime)
  let days = Math.floor(duration.asDays())
  return days >= 0
}

function getDateNowDiffer (start) {
  let diffTime = moment(start, 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'))
  let duration = moment.duration(diffTime)
  let days = duration.asDays() * -1
  return days > 90
}

function isValidOrderId (orderId, searchOption) {
  if (searchOption !== OrderListSearchType.ORDER_NO) {
    return true
  }
  if (!orderId.includes('-')) {
    return false
  }
  let orderIdArr = orderId.split('-')
  if (orderIdArr.length !== 2) {
    return false
  }
  // YYYYmmDD 형식이라 8자리로 체크
  // 주문번호는 7자리까지만
  return orderIdArr[1].length === 7 && orderIdArr[0].length === 8
}

function removeHTML (data) {
  return data.replace(/<\/?[^>]+(>|$)/g, '')
}

export {
  generateOrderListTypeParam,
  convertDate,
  gatherAllItems,
  getImageLinkArr,
  attachImageLink,
  convertCurrency,
  linkReceiverAddress,
  handleNumber,
  handlePrice,
  handleDefaultInfo,
  linkReturnAddress,
  getShipmentChipColor,
  getPaidChipColor,
  getInitDate,
  getDateDiffer,
  isValidOrderId,
  removeHTML,
  getDateNowDiffer
}



// WEBPACK FOOTER //
// ./src/components/menus/cafe24/util/baseUtil.js